import { captureException } from "@sentry/vue";

import { type PushNotificationStore, usePushNotificationsStore } from "../Store";
import { ApiErrorCodes } from "@/Modules/App/Models/Api/ApiErrorCodes";

import PushNotificationsAPIConnector from "@/Services/TherapyApi/PushNotifications";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import { danger } from "@/Utils/Debug";
import { hasValue } from "@/Utils/Objects";

class CheckIsAvailablePushNotificationsActionHandler {
  constructor(
    private readonly pushStore: PushNotificationStore = usePushNotificationsStore(),
    private readonly pushApi = new PushNotificationsAPIConnector()
  ) {}

  public async handle(token: string): Promise<boolean | undefined> {
    try {
      const pushInfo = await this.pushApi.getInfo(token).catch((e) => {
        if (isApiError(e)) {
          if (
            [ApiErrorCodes.USER_LOGED_OUT, ApiErrorCodes.AUTHENTICATION_FAILED].includes(
              e.error_code as ApiErrorCodes
            )
          ) {
            return undefined;
          }
        }

        throw new Error(e);
      });

      if (!hasValue(pushInfo) || !hasValue(pushInfo.enable) || Object.keys(pushInfo).length === 0) {
        this.pushStore.isAvailable = false;

        return undefined;
      }

      if (pushInfo.enable) {
        this.pushStore.isAvailable = true;
      } else {
        this.pushStore.isAvailable = false;
      }

      return this.pushStore.isAvailable;
    } catch (e) {
      this.pushStore.isAvailable = false;

      danger("Error checking push token", e);
      captureException(e);

      return undefined;
    }
  }
}

export default CheckIsAvailablePushNotificationsActionHandler;
